export const SI_HEADER_EXTRA_HEIGHT_PX = 11;
